export enum ImageTypeEnum {
  thumb = 'thumb',
  origin = 'origin',
}
